import { Component, ViewEncapsulation } from '@angular/core';

import { NotificationsBaseComponent } from '../notifications.component';

@Component({
  selector: 'app-descriptive-notification',
  templateUrl: './descriptive-notification.component.html',
  styleUrls: ['./descriptive-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DescriptiveNotificationComponent extends NotificationsBaseComponent {
  constructor() {
    super();
  }
}
